import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { ICompanyMonthReport, ICompanyMonthReportItem } from '@core/main/types';
const hostUrl = getHostbaseUrl();

/**
 * 报表中心 - 企业月度结算报表分页
 */
export async function queryCompanyMonthSettement(param: ICompanyMonthReport) {
  let data = [] as ICompanyMonthReportItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: ICompanyMonthReportItem[]; total: number }>(`${hostUrl}/report/company-monthly-statics/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ICompanyMonthReportItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 报表中心 - 企业月度结算报表分页导出
 */
export async function exportCompanyMonthSettement(param: ICompanyMonthReport) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.post<Blob>(
      `${hostUrl}/report/company-monthly-statics/export`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}